import Translations from "@/components/translations/translations/Translations";
import Dictionary from "@/components/translations/dictionary/Dictionary";
import Tasks from "@/components/translations/tasks/Tasks";

export const translations = [
    {path: '/translations', name: 'translations', component: Translations},
    {path: '/translations/tasks', name: 'translationTasks', component: Tasks},
    {path: '/translations/dictionary', name: 'dictionary', component: Dictionary}
]